import React, { useState, useEffect } from 'react';
import './HelpModal.css';

const HelpModal = ({ isOpen, onClose, onSelectCategory }) => {
    const [purposes, setPurposes] = useState([]);
    const [selectedPurpose, setSelectedPurpose] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (isOpen) {
            fetchPurposes();
        }
    }, [isOpen]);

    const fetchPurposes = async () => {
        setLoading(true);
        try {
            const response = await fetch('/api/purpose/help');
            const data = await response.json();
            setPurposes(data);
        } catch (error) {
            console.error('Error fetching purposes:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleUseThis = async () => {
        if (selectedPurpose) {
            const purpose = purposes.find(p => p.id.toString() === selectedPurpose);
            if (purpose && purpose.suggestedCategory) {
                try {
                    await onSelectCategory(purpose);
                } catch (error) {
                    console.error('Error in onSelectCategory:', error);
                }
            } else {
                console.error('Purpose or suggestedCategory is null:', purpose);
            }
        }
        onClose();
    };

    const handleCancel = () => {
        setSelectedPurpose('');
        onClose();
    };

    const handlePurposeChange = (e) => {
        setSelectedPurpose(e.target.value);
    };

    if (!isOpen) return null;

    return (
        <div className="help-modal-overlay" onClick={handleCancel}>
            <div className="help-modal" onClick={(e) => e.stopPropagation()}>
                <div className="help-modal-header">
                    <h2>Find the Right Category</h2>
                    <button className="help-modal-close" onClick={handleCancel}>&times;</button>
                </div>
                
                <div className="help-modal-content">
                    <p className="help-modal-description">
                        Tell us what you want to do, and we'll suggest the best category for your prompt.
                    </p>
                    
                    <div className="help-modal-form">
                        <label htmlFor="purpose-select" className="help-modal-label">
                            What do you want to do?
                        </label>
                        
                        {loading ? (
                            <div className="help-modal-loading">Loading purposes...</div>
                        ) : (
                            <select
                                id="purpose-select"
                                value={selectedPurpose}
                                onChange={handlePurposeChange}
                                className="help-modal-select"
                            >
                                <option value="">Choose your purpose...</option>
                                {purposes.map(purpose => (
                                    <option key={purpose.id} value={purpose.id}>
                                        {purpose.name}
                                    </option>
                                ))}
                            </select>
                        )}
                        
                        {selectedPurpose && (
                            <div className="help-modal-description-box">
                                {purposes.find(p => p.id.toString() === selectedPurpose)?.description}
                            </div>
                        )}
                    </div>
                </div>
                
                <div className="help-modal-footer">
                    <button 
                        className="help-modal-btn help-modal-btn-cancel" 
                        onClick={handleCancel}
                    >
                        Cancel
                    </button>
                    <button 
                        className="help-modal-btn help-modal-btn-primary" 
                        onClick={handleUseThis}
                        disabled={!selectedPurpose}
                    >
                        Use This!
                    </button>
                </div>
            </div>
        </div>
    );
};

export default HelpModal; 